import React, { useState, useEffect } from 'react';
import axios from 'axios';

function AdminPage() {
  const [danmus, setDanmus] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterType, setFilterType] = useState('all');
  const [stats, setStats] = useState({ danmuCount: 0, userCount: 0, questionCount: 0 });
  const [showCleanDialog, setShowCleanDialog] = useState(false);
  const [cleanType, setCleanType] = useState('danmus');
  const [cleanDays, setCleanDays] = useState('');
  const [cleanLoading, setCleanLoading] = useState(false);

  useEffect(() => {
    fetchDanmus();
    fetchStats();
  }, []);

  const fetchDanmus = async () => {
    try {
      const response = await axios.get('/api/admin/danmus');
      setDanmus(response.data);
    } catch (error) {
      console.error('获取弹幕数据失败:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchStats = async () => {
    try {
      const response = await axios.get('/api/admin/stats');
      setStats(response.data);
    } catch (error) {
      console.error('获取统计信息失败:', error);
    }
  };

  const handleClean = async () => {
    if (!window.confirm('确定要清理数据吗？此操作不可恢复！')) {
      return;
    }

    setCleanLoading(true);
    try {
      const response = await axios.post('/api/admin/clean', {
        type: cleanType,
        days: cleanDays ? parseInt(cleanDays) : null
      });
      
      // 显示成功消息
      alert(response.data.message || '清理完成');
      setShowCleanDialog(false);
      setCleanDays('');
      
      // 刷新数据
      await fetchDanmus();
      await fetchStats();
      
    } catch (error) {
      console.error('清理数据失败:', error);
      
      // 更详细的错误处理
      let errorMessage = '清理失败';
      
      if (error.response) {
        // 服务器返回了错误状态码
        errorMessage = error.response.data?.error || `服务器错误 (${error.response.status})`;
        if (error.response.data?.details) {
          console.error('错误详情:', error.response.data.details);
        }
      } else if (error.request) {
        // 网络错误
        errorMessage = '网络连接失败，请检查网络后重试';
      } else {
        // 其他错误
        errorMessage = error.message || '未知错误';
      }
      
      alert(`清理失败: ${errorMessage}`);
    } finally {
      setCleanLoading(false);
    }
  };

  const filteredDanmus = danmus.filter(danmu => {
    const matchesSearch = 
      danmu.content.toLowerCase().includes(searchTerm.toLowerCase()) ||
      danmu.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      danmu.student_id.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesType = filterType === 'all' || danmu.type === filterType;
    
    return matchesSearch && matchesType;
  });

  if (loading) {
    return (
      <div className="container">
        <div>加载中...</div>
      </div>
    );
  }

  return (
    <div className="container">
      <h1>后台管理 - 弹幕记录</h1>
      <p style={{color: '#666', marginBottom: '20px'}}>
        这里可以查看所有弹幕的真实发送者身份信息
      </p>

      {/* 统计信息 */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '15px',
        marginBottom: '20px'
      }}>
        <div style={{
          padding: '15px',
          backgroundColor: '#f8f9fa',
          borderRadius: '8px',
          textAlign: 'center'
        }}>
          <div style={{fontSize: '24px', fontWeight: 'bold', color: '#007bff'}}>
            {stats.danmuCount}
          </div>
          <div style={{color: '#666'}}>弹幕总数</div>
        </div>
        <div style={{
          padding: '15px',
          backgroundColor: '#f8f9fa',
          borderRadius: '8px',
          textAlign: 'center'
        }}>
          <div style={{fontSize: '24px', fontWeight: 'bold', color: '#28a745'}}>
            {stats.userCount}
          </div>
          <div style={{color: '#666'}}>用户总数</div>
        </div>
        <div style={{
          padding: '15px',
          backgroundColor: '#f8f9fa',
          borderRadius: '8px',
          textAlign: 'center'
        }}>
          <div style={{fontSize: '24px', fontWeight: 'bold', color: '#ffc107'}}>
            {stats.questionCount}
          </div>
          <div style={{color: '#666'}}>题目总数</div>
        </div>
      </div>

      <div style={{marginBottom: '20px', display: 'flex', gap: '10px', alignItems: 'center'}}>
        <input
          type="text"
          placeholder="搜索弹幕内容、姓名或学号..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{flex: 1, padding: '8px', borderRadius: '4px', border: '1px solid #ddd'}}
        />
        
        <select 
          value={filterType} 
          onChange={(e) => setFilterType(e.target.value)}
          style={{padding: '8px', borderRadius: '4px', border: '1px solid #ddd'}}
        >
          <option value="all">所有类型</option>
          <option value="text">文本</option>
          <option value="image">图片</option>
        </select>

        <button className="btn" onClick={fetchDanmus}>
          刷新
        </button>
        
        <button 
          className="btn" 
          style={{backgroundColor: '#dc3545', borderColor: '#dc3545'}}
          onClick={() => setShowCleanDialog(true)}
        >
          数据清理
        </button>
      </div>

      <div style={{marginBottom: '10px'}}>
        总计: {filteredDanmus.length} 条弹幕
      </div>

      <div style={{overflowX: 'auto'}}>
        <table className="admin-table">
          <thead>
            <tr>
              <th>时间</th>
              <th>姓名</th>
              <th>学号</th>
              <th>题目</th>
              <th>类型</th>
              <th>内容</th>
              <th>图片</th>
            </tr>
          </thead>
          <tbody>
            {filteredDanmus.map(danmu => (
              <tr key={danmu.id}>
                <td>{new Date(danmu.created_at).toLocaleString()}</td>
                <td style={{fontWeight: 'bold', color: '#007bff'}}>{danmu.name}</td>
                <td>{danmu.student_id}</td>
                <td>{danmu.question_title || '无题目'}</td>
                <td>
                  <span style={{
                    padding: '2px 6px',
                    borderRadius: '3px',
                    backgroundColor: danmu.type === 'text' ? '#28a745' : '#17a2b8',
                    color: 'white',
                    fontSize: '12px'
                  }}>
                    {danmu.type === 'text' ? '文本' : '图片'}
                  </span>
                </td>
                <td style={{maxWidth: '200px', wordBreak: 'break-word'}}>
                  {danmu.content}
                </td>
                                 <td>
                   {danmu.image_url && (
                     <img 
                       src={danmu.image_url}
                       alt="弹幕图片"
                       style={{
                         maxWidth: '100px',
                         maxHeight: '60px',
                         borderRadius: '4px',
                         cursor: 'pointer'
                       }}
                       onClick={() => window.open(danmu.image_url, '_blank')}
                     />
                   )}
                 </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {filteredDanmus.length === 0 && (
        <div style={{textAlign: 'center', padding: '40px', color: '#666'}}>
          {searchTerm || filterType !== 'all' ? '没有找到匹配的弹幕' : '暂无弹幕数据'}
        </div>
      )}

      {/* 数据清理对话框 */}
      {showCleanDialog && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '8px',
            minWidth: '400px',
            maxWidth: '500px'
          }}>
            <h3 style={{marginTop: 0, marginBottom: '20px'}}>数据清理</h3>
            
            <div style={{marginBottom: '15px'}}>
              <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>
                清理类型:
              </label>
              <select 
                value={cleanType} 
                onChange={(e) => setCleanType(e.target.value)}
                style={{
                  width: '100%',
                  padding: '8px',
                  borderRadius: '4px',
                  border: '1px solid #ddd'
                }}
              >
                <option value="danmus">弹幕数据</option>
                <option value="users">用户数据</option>
                <option value="questions">题目数据</option>
                <option value="all">所有数据</option>
              </select>
            </div>

            {cleanType !== 'all' && (
              <div style={{marginBottom: '15px'}}>
                <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>
                  清理天数 (可选，留空清理所有):
                </label>
                <input
                  type="number"
                  value={cleanDays}
                  onChange={(e) => setCleanDays(e.target.value)}
                  placeholder="例如: 7 (清理7天前的数据)"
                  style={{
                    width: '100%',
                    padding: '8px',
                    borderRadius: '4px',
                    border: '1px solid #ddd'
                  }}
                />
              </div>
            )}

            <div style={{
              padding: '15px',
              backgroundColor: '#fff3cd',
              border: '1px solid #ffeaa7',
              borderRadius: '4px',
              marginBottom: '20px'
            }}>
              <strong>⚠️ 警告:</strong> 此操作不可恢复！请谨慎操作。
              {cleanType === 'all' && (
                <div style={{marginTop: '10px', color: '#856404'}}>
                  将清理所有弹幕、用户和题目数据！
                </div>
              )}
            </div>

            <div style={{display: 'flex', gap: '10px', justifyContent: 'flex-end'}}>
              <button 
                className="btn"
                onClick={() => setShowCleanDialog(false)}
                disabled={cleanLoading}
              >
                取消
              </button>
              <button 
                className="btn"
                style={{backgroundColor: '#dc3545', borderColor: '#dc3545'}}
                onClick={handleClean}
                disabled={cleanLoading}
              >
                {cleanLoading ? '清理中...' : '确认清理'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminPage;